module.exports = __webpack_public_path__ + "src/img/bigStar.d92f2c6e.png";